import React from "react";

/// React router dom
import { Switch, Route } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";
/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
import Main from "./layouts/Main";
/// Auth initialization
import AuthInit from "./AuthInit";
/// Plugins
/// paginas 
import Marcacion from "./pages/Marcacion";
import Usuarios from "./pages/Usuarios";
import Liquidaciones from "./pages/Liquidaciones";
import Clientes from "./pages/Clientes";
import FichaUser from "./pages/Fichausuario";
import FichaCliente from "./pages/Fichaclientes.js";
import Sesiones from "./pages/Sesiones.js";
import Cierre from "./pages/liquidacion/Cierre.js";
import OrdenDePago from "./pages/Ordendepago.js"; // Added import
/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";
/// Pages
import Login from "./pages/Login";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Termino from "./pages/Terminos.js";
import FichaLiquidacion from "./pages/liquidacion/Fichaliquidacion.js";
import FichaLegajo from "./pages/sesiones/FichaLegajo.js";
import FichaOrden from "./pages/ordendepago/FichaOrden.js";
import Opciones from "./pages/Opciones.js";
import Admin from "./pages/admin/admin.js";
import Pagos from "./pages/pagos/pagos.js";
import Alquileres from "./pages/alquileres/alquileres.js";
import Appclientes from "./pages/appclientes/appclientes.js";
const Markup = () => {
  const routes = [
    { url: "marcacion", component: Marcacion },
    { url: "usuarios", component: Usuarios },
    { url: "liquidaciones", component: Liquidaciones },
    { url: "legajo/:id", component: FichaLegajo },
    { url: "clientes", component: Clientes },
    { url: "Fichausuario/:id", component: FichaUser },
    { url: "Fichaclientes/:id", component: FichaCliente },
    { url: "Fichaorden/:id", component: FichaOrden },
    { url: "sesiones", component: Sesiones },
    { url: "cierre", component: Cierre },
    { url: "ordendepago", component: OrdenDePago }, // Added route
    { url: "fichaliquidacion/:id", component: FichaLiquidacion },
    { url: "opciones", component: Opciones },
    { url: "admin", component: Admin },
    { url: "datatable-filtering", component: FilteringTable },
    { url: "datatable-sorting", component: SortingTable },
    { url: "table-bootstrap-basic", component: BootstrapTable },
    { url: "pagos", component: Pagos },
    { url: "alquileres", component: Alquileres },
    { url: "appclientes", component: Appclientes }
  ];

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let pagePath = path.split("-").includes("page");

  return (
    <>
      <AuthInit />
      <Switch>
        {/* without layouts (nav, header, sidebar and footer) */}
        <Route path="/login" component={Login} />
        <Route path="/page-error-400" component={Error400} />
        <Route path="/page-error-403" component={Error403} />
        <Route path="/page-error-404" component={Error404} />
        <Route path="/page-error-500" component={Error500} />
        <Route path="/page-error-503" component={Error503} />
        <Route path="/Termino" component={Termino} />

        <Route path="/" exact>
          {/* You can add a default component here if needed */}
        </Route>
        <Route>
          <div id="main-wrapper" className="show">
            <Main>
              <Nav />
              <div className="layout-wrapper">
                <div className="content-body">
                  <div className="container-fluid">
                    <Switch>
                      {routes.map((data, i) => (
                        <Route
                          key={i}
                          exact
                          path={`/${data.url}`}
                          component={data.component}
                        />
                      ))}
                    </Switch>
                  </div>
                </div>
                <Footer />
              </div>
            </Main>
          </div>
        </Route>
      </Switch>
      <ScrollToTop />
    </>
  );
};

export default Markup;